import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import PageTitle from "../../Components/PageTitle"; 
import { ConfigContext } from "../../Context/ConfigContext"; 
import { currentDateAndTime } from "../../Constants/constants";
import Swal from "sweetalert2";
import LazyImage from "../../Components/LazyImage";



const AdminBasicDetails = () => {
  const { apiURL, apiHeaderJSON,apiHeaderFile, employee_id,setCompanyName } = useContext(ConfigContext);
  const [adminBasicData, setAdminBasicData] = useState({});
  const [companyData, setCompanyData] = useState({});
  const [logoData, setLogoData] = useState({});
  const [viewProfile, setViewProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [allPages, setAllPages] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);

  

  useEffect(() => {
    getCompanyData();
  }, []);
 const getCompanyData = () => {
    setLoading(true);
    let options = {
      url: `${apiURL}Employees/CompanyUserDetails?limit=${limit}&page=${page}`,
      method: "GET",
      headers: apiHeaderJSON,
    };
    axios(options)
      .then((response) => {
        // console.log("getEmployeeOnboardingData ~ response", response?.data);
        let res = response?.data;
        if (response.data.success === true) {
          console.log("getCompanyData ~ res", res);
          localStorage.setItem("company_code",res?.data[0]?.company_code);
          setCompanyName(res?.data[0]?.company_user_name);
          setCompanyData(res?.data[0]);
          setPage(res?.page);
          setAllPages(res?.total_pages);
          setTotalRecords(parseInt(res?.total_records));
          setLogoData(res?.logo_data[0]);
        } else if (response.data.success === false) {
        }

        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };




  const handleFileChange = (event) => {
    const file = event.target.files[0];
  
    if (file) {
      const maxSize = 1 * 1024 * 1024; 
  
      if (file.size > maxSize) {
        Swal.fire({
          title: "<strong>File Too Large</strong>",
          text: "Please upload an image smaller than 1 MB.",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        return; 
      }
  
      setSelectedFile(file);
      uploadProfilePicture(file);
    }
  };
  
  
  const uploadProfilePicture = async (file) => {
    const formData = {
      file: file,
      date: currentDateAndTime(),
    };
   
  
    try {
      const response = await axios.post(
        `${apiURL}Employees/UpdateAdminProfile`, 
        formData, 
        {
          headers: apiHeaderFile,
        }
      );
  
      if (response.data.success) {
        // console.log("Profile picture updated successfully!", response.data);
        Swal.fire({
          title: "<strong>Success</strong>",
          text: "Successfully uploaded profile picture.",
          icon: "success",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      } else {
        console.error("Profile update failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error uploading profile picture:", error);
    }
  };

  return (
    <div>
      {!loading ? (
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <br />
              <PageTitle title="Profile" primary="Dashboard" />
              <div className="card mt-10">
                <div className="card-body p-4 text-center">
                  {/* <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                    <img
                      src={adminBasicData?.employee_profile_url || "assets/profile-pic.png"}
                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                      alt="user-profile-picture"
                    />
                  </div> */}
                  <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                  {/* <img
                      src={adminBasicData?.employee_profile_url || "assets/profile-pic.png"}
                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                      alt="user-profile-picture"
                    /> */}
                    <span onClick={()=>{ companyData?.admin_profile_url && setViewProfile(true)}}>
                      <LazyImage src={`${companyData?.admin_profile_url || "assets/profile-pic.png"}`} 
                      alt="user-profile-picture" className="rounded-circle cursorPointer avatar-xl img-thumbnail user-profile-image" />
                    </span>
                  <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                    <input id="profile-img-file-input" type="file"  className="profile-img-file-input" onChange={handleFileChange} />
                    <label htmlFor="profile-img-file-input" className="profile-photo-edit avatar-xs">
                      <span className="avatar-title rounded-circle bg-light text-body">
                        <i className="ri-camera-fill" />
                      </span>
                    </label>
                  </div>
                </div>
                  {/* <h5 className="fs-16 mb-1">{adminBasicData?.employee_name}</h5>
                  <p className="text-muted mb-0">{adminBasicData?.designation_title}</p>
                  <p className="text-muted mb-0">{adminBasicData?.department_title}</p> */}
                </div>
              
              {viewProfile && (
                <div className="modal show" tabIndex={-1}
                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                    aria-labelledby="myModalLabel"
                    aria-hidden="true">
                    <div className=" m-auto mt-3"
                     style={{ width: "30%", }}>
                        <div className="modal-content">
                        <div className="modal-header pb-0">
                            <button
                            type="button"
                            onClick={()=>{ setViewProfile(false); }}
                            className="btn-close"
                            aria-label="Close"
                            />
                        </div>
                        <div className="modal-body py-0 d-flex align-items-center justify-content-center">
                          <div className="profile-container">
                            <img
                              src={companyData?.admin_profile_url}
                              alt="profile"
                              width="100%"
                            />
                          </div>
                        </div>                       
                        </div>
                    </div>
                </div>
              )}
              </div>
             <div>
                <div className="card-body p-4 bg-white">
                <div className="tab-content">
                <div className="tab-pane active show" id="personalDetails" role="tabpanel">
                 <form action="javascript:void(0);">
                             <div className="row">
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <label htmlFor="firstnameInput" className="form-label">Full Name</label>
                                                 <input value={companyData?.company_user_name || "--"} type="text" className="form-control" id="firstnameInput"  />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                             <label htmlFor="firstnameInput" className="form-label">Company Name</label>
                                             <input value={logoData?.company_name || "--" } type="text" className="form-control" id="firstnameInput" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <label htmlFor="firstnameInput" className="form-label">User Id</label>
                                            <input value={companyData?.company_user_login_id || "--"} type="text" className="form-control" id="firstnameInput"  />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='mb-3'>
                                            <label htmlFor="firstnameInput" className='form-label'>email id</label>
                                            <input value={companyData?.company_user_email || "--"} type="text"
                                             className="form-control" id="firstnameInput" />
                                        </div>
                                    </div>                                
                    </div>                               
                </form>
        </div>                                                                       
        </div>
        </div>                              
    </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "90vh" }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminBasicDetails;
